<template>
    <svg class="size-4 fill-gray-600" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path></svg>
</template>

<script setup>
</script>